import SliceNames from '@/state/enum';
import { NavigationState } from '@/state/slices/navigation/typings';

const navigationState: NavigationState = {
	[SliceNames.NAVIGATION]: {
		open: false,
		dropdownSegments: [],
		genericDropdownState: {},
		animationDuration: 400,
		models: {},
		dropdownId: 'mobile-menu',
		animationDirection: 'top',
	},
};

export default navigationState;
